export default __webpack_public_path__ + "static/media/wanda.545628e1.png";